export default __webpack_public_path__ + "static/media/PUBLI_3_ORG_12.5b474e10.png";